import { Optional } from '@angular/core';

export class Product {
    constructor(
        public name: string,
        public description: string,
        public comment: string,
        public googlePlayStoreUrl: string,
        public appleAppStoreUrl: string,
        public videoUrl?: string,
        public imagesUrls?: string[]) {}
}
